/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getExecutiveBudgetTable = params => {
  return axios.post(`${base}/executive-budget/query_project`, params)
}
export const getExecutiveBudgetDetail = params => {
  return axios.post(`${base}/executive-budget/query_province`, params)
}
export const editExecutiveBudgetStatus = params => {
  return axios.post(`${base}/executive-budget/edit_status_pass_${params.id}`, params)
}
export const updateExecutiveBudgetAudit = params => {
  return axios.post(`${base}/executive-budget/edit_status_audit_${params.id}`, params)
}
export const editExecutiveBudget = params => {
  return axios.post(`${base}/executive-budget/edit_province_${params.id}`, params)
}

// 执行审批页
export const getExecutiveApproveTable = params => {
  return axios.post(`${base}/executive-audit/query_audit`, params)
}

// 执行补贴验证和获取剩余预算
export const getExecutiveAllowance = params => {
  return axios.post(`${base}/executive-audit/get_subsidise_user`, params)
}
// 执行补贴申请
export const executiveAllowanceApply = params => {
  return axios.post(`${base}/executive-audit/subsidise_user`, params)
}

export const editExecutiveAuditStatus = params => {
  return axios.post(`${base}/executive-audit/edit_status_${params.id}`, params)
}




// WEBPACK FOOTER //
// ./src/views/executive-budget/executive-budget.api.js